import _extends from "@babel/runtime/helpers/esm/extends";
import { CoreTypographyThemeVariants } from './typographyVariants';
export var MuiAlertOverrides = {
  styleOverrides: {
    root: {
      '.MuiButton-sizeSmall': {
        backgroundColor: 'inherit',
        minHeight: '20px'
      },
      maxWidth: '312px',
      minHeight: '52px',
      alignItems: 'center'
    },
    action: {
      paddingTop: 0,
      '.MuiButton-root': {
        '&:hover': {
          backgroundColor: 'inherit'
        },
        '.MuiSvgIcon-root': {
          marginLeft: '20px',
          fontSize: '1rem'
        }
      }
    },
    message: _extends({}, CoreTypographyThemeVariants.body2)
  }
};